import { useRanking } from '../hooks/useRanking'
import { useAuth } from '../contexts/AuthContext'

export default function Ranking() {
  const { ranking, semanaAtual, loading, erro } = useRanking()
  const { membroAtual } = useAuth()

  const pickRevelado = semanaAtual?.picks_revelados === true

  const ativos = ranking.filter(p => p.vidas_restantes > 0)
  const eliminados = ranking.filter(p => p.vidas_restantes === 0)

  return (
    <div>
      <div style={s.banner}>
        <span>
          {ativos.length} ativos · {eliminados.length} eliminados ·
          desempate: vidas → spread médio → vidas médias
        </span>
      </div>

      {loading && <div style={s.loading}>Carregando ranking...</div>}
      {erro && <div style={s.erro}>{erro}</div>}

      {!loading && (
        <table style={s.table}>
          <colgroup>
            <col style={{ width: 28 }} />
            <col />
            <col style={{ width: 58 }} />
            <col style={{ width: 52 }} />
            <col style={{ width: 60 }} />
            <col style={{ width: 72 }} />
          </colgroup>
          <thead>
            <tr>
              <th style={s.th}>#</th>
              <th style={s.th}>Participante</th>
              <th style={s.th}>Pick atual</th>
              <th style={{ ...s.th, textAlign: 'center' }}>Vidas</th>
              <th style={s.th}>Sprd méd.</th>
              <th style={s.th}>Vidas médias</th>
            </tr>
          </thead>
          <tbody>
            {[...ativos, ...eliminados].map((p, i) => {
              const sou = p.membro_id === membroAtual?.id
              const elim = p.vidas_restantes === 0
              const pos = elim ? '—' : i + 1
              const hearts = p.vidas_restantes > 0
                ? '♥'.repeat(p.vidas_restantes)
                : '✕'
              const heartColor = p.vidas_restantes > 0 ? '#D85A30' : '#bbb'

              // Pick: só mostra o time se picks estiverem revelados
              // Se não revelado: mostra ✓ (fez pick) ou — (não fez)
              let pickCell
              if (pickRevelado && p.pick_semana_atual) {
                pickCell = <span style={s.pickBadge}>{p.pick_semana_atual}</span>
              } else if (!pickRevelado && p.pick_semana_atual) {
                pickCell = <span style={s.pickFeito}>✓</span>
              } else {
                pickCell = <span style={{ color: '#bbb', fontSize: 11 }}>—</span>
              }

              return (
                <tr key={p.membro_id} style={elim ? s.elimRow : {}}>
                  <td style={{ ...s.td, color: '#bbb', fontSize: 11 }}>{pos}</td>
                  <td style={{ ...s.td, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {p.nome}
                    {sou && <span style={s.youTag}>você</span>}
                  </td>
                  <td style={s.td}>
                    {pickCell}
                  </td>
                  <td style={{ ...s.td, textAlign: 'center', color: heartColor, fontSize: 11 }}>
                    {hearts}
                  </td>
                  <td style={{ ...s.td, color: '#888' }}>
                    {p.spread_medio != null ? Number(p.spread_medio).toFixed(2) : '—'}
                  </td>
                  <td style={{ ...s.td, color: '#888' }}>
                    {p.vidas_medias != null ? Number(p.vidas_medias).toFixed(2) : '—'}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}

const s = {
  banner: { background: '#EAF3F8', border: '0.5px solid #378ADD', borderRadius: 8, padding: '8px 12px', marginBottom: '.9rem', fontSize: 12, color: '#1A5C9A' },
  loading: { fontSize: 13, color: '#888', padding: '1.5rem 0', textAlign: 'center' },
  erro: { background: '#FCEBEB', color: '#A32D2D', fontSize: 13, padding: '8px 12px', borderRadius: 8 },
  table: { width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' },
  th: { fontSize: 11, color: '#888', textAlign: 'left', padding: '0 6px 8px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '.04em' },
  td: { padding: '8px 6px', fontSize: 12, borderTop: '0.5px solid #eee' },
  elimRow: { opacity: 0.5 },
  youTag: { fontSize: 10, background: '#FAECE7', color: '#993C1D', borderRadius: 99, padding: '1px 5px', marginLeft: 5 },
  pickBadge: { fontSize: 11, padding: '2px 6px', background: '#f5f5f5', borderRadius: 6 },
  pickFeito: { fontSize: 13, color: '#3B6D11', fontWeight: 500 },
}
